<script setup lang="ts">
import { useSite } from "@/api/site-query";
import SiteSelection from "./SiteSelection.vue";

const emit = defineEmits(["close"]);
const props = defineProps({
	id: { type: String, required: true },
});
const id = computed(() => props.id);
const { site, isLoading } = useSite(id);

function close() {
	emit("close");
}
</script>

<template>
	<SiteSelection
		v-if="site"
		class="border-border border"
		:site="site"
		:isLoading="isLoading"
		@close="close"
	/>
</template>
